// extracted by mini-css-extract-plugin
export default {"container":"CollectionYardsTable_container__FMrXV"};